import React from 'react';

export const SectionDivider: React.FC<{ label: string }> = ({ label }) => (
  <div className="flex items-center my-4">
    <div className="flex-grow border-t border-gray-200"></div>
    <span className="mx-2 text-md font-bold text-gray-500">{label}</span>
    <div className="flex-grow border-t border-gray-200"></div>
  </div>
);